import type { EditorView } from '@tiptap/pm/view';
import { Slice } from '@tiptap/pm/model';
import { useEffect } from 'react';
import { wysiwygCopyLocalStorage } from 'storage/components';

export const handleCopy = (view: EditorView, event: ClipboardEvent) => {
  if (view.state.selection.empty) {
    return false;
  }

  const slice = view.state.selection.content().toJSON();

  wysiwygCopyLocalStorage.val = slice;

  event.stopPropagation();

  return false;
};

export const handlePaste = (view: EditorView, event: ClipboardEvent) => {
  const data = wysiwygCopyLocalStorage.val;

  if (!data) {
    return false;
  }

  event.preventDefault();

  const slice = Slice.fromJSON(view.state.schema, data);

  view.dispatch(view.state.tr.replaceSelection(slice).scrollIntoView());

  return true;
};

export const WYSIWYGCopyPaste = () => {
  useEffect(() => {
    const listener = (_event: ClipboardEvent | FocusEvent) => {
      wysiwygCopyLocalStorage.clear();
    };

    document.addEventListener('copy', listener);
    document.addEventListener('cut', listener);
    window.addEventListener('blur', listener);

    return () => {
      document.removeEventListener('copy', listener);
      document.removeEventListener('cut', listener);
      window.removeEventListener('blur', listener);
    };
  }, []);

  return null;
};
